<script>
  import { mileageStore } from '../../stores'
  import { config } from '../../../scripts/defaultURL'
  import { formatPayloadDate } from '../../../scripts/functions'
  import { updateData } from '../../../scripts/rest'

  export let mileageEntry
  export let mileageData

  let date = mileageEntry.date.split('T')[0] // YYYY-MM-DD for input type="date"
  let destination = mileageEntry.destination || ''
  let mileage = mileageEntry.mileage

  function closeModal() {
    date = ''
    destination = ''
    mileage = ''
    document.getElementById('editMileageModal')?.classList.remove('is-active')
    mileageStore.update(store => {
      store['todo'] = 'getData';
      return store;
    })
  }

  async function save(e) {
    e.preventDefault()

    const payload = {
      id: mileageEntry.id,
      date: formatPayloadDate(date),
      destination,
      mileage: Number(mileage) || 0,
    }

    console.log('Sending payload:', payload)

    try {
      const res = await updateData(
        `${config.defaultURL}/mileage/update/${payload.id}`,
        payload
      )
      console.log('Update response:', res)
      closeModal()
    } catch (err) {
      console.error('Failed to update mileage:', err)
    }
  }
</script>

<div class="modal" id="editMileageModal">
  <div class="modal-background" />
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">Edit Mileage</p>
      <button on:click={closeModal} class="delete" aria-label="close" />
    </header>
    <section class="modal-card-body">
      <form on:submit|preventDefault={save}>
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Date</label>
          <input
            id="date"
            bind:value={date}
            class="input"
            type="date"
            placeholder="Select Date"
          />
        </div>
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Destination</label>
          <input
            id="destination"
            list="destinations"
            bind:value={destination}
            class="input"
            placeholder="Travel Destination"
          />
          <datalist id="destinations">
            {#each mileageData as dest}
              <option>{dest}</option>
            {/each}
          </datalist>
        </div>
        <div class="field">
          <!-- svelte-ignore a11y-label-has-associated-control -->
          <label class="label">Miles Traveled</label>
          <input
            id="mileage"
            bind:value={mileage}
            type="text"
            class="input"
            placeholder="# Miles"
          />
        </div>
        <div class="field is-grouped">
          <div class="control">
            <button on:click={save} type="submit" class="button is-primary"
              >Submit</button
            >
          </div>
          <div class="control">
            <button
              type="reset"
              on:click={closeModal}
              class="button is-primary is-light">Cancel</button
            >
          </div>
        </div>
      </form>
    </section>
  </div>
</div>

<style>
  .modal-card-title {
    margin-bottom: 0 !important;
  }
</style>
